namespace $.$$ {

	export class $shm_hitalama_agent_tool_card extends $.$shm_hitalama_agent_tool_card {

		rows() {
			return [
				this.Head(),
				... this.input().trim() ? [ this.Input() ] : [],
				... this.options().length ? [ this.Options() ] : [],
				... this.content().trim() ? [ this.Content() ] : [],
				... this.error().trim() ? [ this.Error() ] : [],
			]
		}

		title() {
			return this.name() ? `Tool · ${ this.name() }` : 'Tool'
		}

		status_title() {
			const status = this.status()
			if( status === 'running' ) return 'идёт'
			if( status === 'completed' || status === 'done' || status === 'success' ) return 'готово'
			if( status === 'error' || status === 'failed' ) return 'ошибка'
			return status
		}

		copy_text() {
			return [
				this.title(),
				this.status_title(),
				this.input(),
				this.content(),
				this.error(),
			].filter( Boolean ).join( '\n\n' )
		}

	}

}
